import { render } from "./MainWindow.vue?vue&type=template&id=1dd424a5"
import script from "./MainWindow.vue?vue&type=script&lang=js"
export * from "./MainWindow.vue?vue&type=script&lang=js"

import "./MainWindow.vue?vue&type=style&index=0&id=1dd424a5&noscoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__